"use strict";

exports.__esModule = true;
exports.default = void 0;

var getNumberAttributes = function getNumberAttributes(locale) {
  switch (locale) {
    case 'fr':
    case 'fr-CA':
    case 'fr_CA':
      return {
        thousandSeparator: ' ',
        decimalSeparator: ','
      };

    case 'en':
    case 'en-CA':
    case 'en_CA':
    default:
      return {
        thousandSeparator: ',',
        decimalSeparator: '.'
      };
  }
};

var _default = getNumberAttributes;
exports.default = _default;